export const en = {
  message: {
    layout: {
      login: 'Login',
      logout: 'Logout'
    },
    login: {
      language: 'Language',
      back: 'Back',
      userName: 'Username',
      password: 'Password',
      authFailed: 'Authentication failed !',
      enterUserName: 'Enter User Name',
      enterPassword: 'Enter Password',
      enterConfirmPassword: 'Confirm Your Password',
      resetNow: 'Reset Now',
      invalidPassword: 'Invalid Password',
      unauthorizedMsg: 'You are not authorized',
      forgotPassword: 'Forgot password?',
      mailNotFound: 'Email not found',
      linkShared: 'Reset link has been successfully sent!',
      office365: 'Login in with Office 365',
      or: 'Or'
    },
    common: {
      close: 'Close',
      newUpdate: 'New Update Available!',
      translate: 'Translate',
      required: 'Required',
      refresh: 'Refresh',
      name: 'Name',
      english: 'English',
      norwegian: 'Norwegian',
      save: 'Save',
      send: 'Send',
      edit: 'Edit',
      cancel: 'Cancel',
      update: 'Update',
      delete: 'Delete',
      updateAndClose: 'Update & Close',
      savedSuccess: 'Saved successfully!',
      addedSucess: 'Added successfully !',
      updatedSuccess: 'Updated successfully !',
      deleteSuccess: 'Deleted successfully !',
      backToList: 'Back To List',
      search: 'Search',
      yes: 'Yes',
      no: 'No',
      deleteMsg: 'Deleted Successfully',
      loadingMsg: 'Loading, Please wait',
      deleteConfirm: 'Delete Confirm',
      areYouSure: 'Are you sure you want to delete ?',
      validationIssue: 'Please check the required fields!',
      invalidNumber: 'Invalid Number',
      warning: 'Warning',
      confirmation: 'Confirmation',
      filters: 'Filters',
      others: 'Others'
    },
    dashboard: {
      scanText: 'Scan order number or barcode',
      customerOrder: 'Customer orders',
      receiveSupplierOrder: 'Purchase orders',
      adjustmentOrders: 'Adjustment orders',
      transferOrders: 'Transfer orders',
      cycleCount: 'Cycle count',
      product: 'Product',
      inStoreSale: 'In store sale'
    },
    product: {
      noProductFound: 'No Product Found!',
      minQty: 'Min Qty',
      orderQty: 'Order Qty',
      qty: 'Qty',
      qtyShort: 'Qty',
      batch: 'Batch',
      scanLoc: 'Scan Loc.',
      noLocFound: 'No Location Found!'
    },
    order: {
      products: 'Products',
      avail: 'Avail',
      ordered: 'Ord.',
      orderedshort: 'O.',
      shipmentshort: 'S.',
      confirmedshort: 'C.',
      requestedshort: 'R.',
      send_week: 'Week',
      received: 'Rec.',
      pickedQty: 'Pic.',
      pickOrder: 'Pick order',
      delivery: 'Del',
      rest: 'Rest',
      complete: 'Complete',
      pick: 'Pick',
      scanProduct: 'Scan barcode of a product',
      scanBatch: 'Scan batchnumber',
      picked: 'Picked',
      toPick: 'To pick',
      location: 'Loc',
      pickLocation: 'Select location',
      qtyExceeds: 'Qty Exceeds',
      noOrderFound: 'No order found!',
      notValidBatch: 'Batchnumber is not valid!',
      receiveOrder: 'Receive order',
      receive: 'Receive',
      batchExists: 'Batch number already exists!',
      receiveWarning: 'Would you like to add {qty} pcs of {product} to stock?',
      receiveLessWarning: 'Receiving qty is less than ordered. Still add {qty} pcs of {product} to stock?',
      completedSuccess: 'Completed successfully!',
      addFreight: 'Do you want to add freight?',
      cost: 'Cost',
      price: 'Price',
      orderedQtyHigh: 'Qty received is higher than ordered, would you like to proceed?',
      collect: 'Collect',
      receiving: 'Receiving',
      availableToPick: 'Avail qty(s) to receive',
      adjust: 'Adjust',
      orderComplete: 'Order will be completed. Continue?',
      customer: 'Customer',
      yourReference: 'Your reference',
      standardOrderText: 'Standard order text',
      total: 'Total',
      selectSuppliers: 'Select suppliers'
    },
    ccsheet: {
      warehouse: 'Warehouse',
      created: 'Created',
      counted: 'Counted',
      count: 'Count',
      reCount: 'Recount',
      closeComplete: 'Close & Complete',
      unit: 'Unit',
      stock: 'Stock',
      scanLocation: 'Scan or enter location',
      nextLoc: 'Next Loc',
      info: 'Message!',
      continueCount: 'Continue counting',
      clearAndRecount: 'Clear & recount',
      completeRecount: 'Complete recount',
      ccsheetComplete: 'CCSheet will be completed. Continue?',
      noSheetFound: 'No CCSheet Found!',
      noProductOnLocation: 'No product is found on this location!',
      stockTake: 'Stock take for the chosen location has already been performed. Do you want to continue counting in this location or clear data and perform new stock take?',
      ccsheetAddProduct: 'Product is not added to this ccsheet would like to add ?'
    }
  }
}
